import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    const pixelId = '2469194336841940';
    if ((window as any).fbq) return;
    const f = window as any;
    f.fbq = function () {
      f.fbq.callMethod ? f.fbq.callMethod.apply(f.fbq, arguments) : f.fbq.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = f.fbq;
    f.fbq.push = f.fbq;
    f.fbq.loaded = true;
    f.fbq.version = '2.0';
    f.fbq.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', pixelId);
    f.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-128">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=2469194336841940&ev=PageView&noscript=1" alt="" data-id="element-129" />
    </noscript>;
}